var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestflight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1076_5884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 -9.5H38C43.523 -9.5 48 -5.023 48 0.5V28.5C48 34.023 43.523 38.5 38 38.5H10C4.477 38.5 0 34.023 0 28.5V0.5C0 -5.023 4.477 -9.5 10 -9.5Z",
    fill: "url(#paint0_linear_1076_5884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9331 5.4175C10.9987 6.07375 10.4869 6.625 9.84375 6.625H6.5625C6.32188 6.625 6.10313 6.72125 5.94563 6.88313C5.78375 7.04063 5.6875 7.25938 5.6875 7.5C5.6875 7.98125 6.08125 8.375 6.5625 8.375H7.21875C7.58187 8.375 7.875 8.66813 7.875 9.03125C7.875 9.39437 7.58187 9.6875 7.21875 9.6875H3.5V8.8125C3.5 6.3975 5.46 4.4375 7.875 4.4375H9.7825C10.3556 4.4375 10.8762 4.84875 10.9331 5.4175Z",
    fill: "url(#paint1_linear_1076_5884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5057 24.4575C17.4401 23.8012 17.9519 23.25 18.5951 23.25H20.5638C20.8044 23.25 21.0232 23.1537 21.1807 22.9919C21.3426 22.8344 21.4388 22.6156 21.4388 22.375C21.4388 21.8937 21.0451 21.5 20.5638 21.5H19.9076C19.5444 21.5 19.2513 21.2069 19.2513 20.8438C19.2513 20.4806 19.5444 20.1875 19.9076 20.1875H24.5013V21.0625C24.5013 23.4775 22.5413 25.4375 20.1263 25.4375H18.6563C18.0832 25.4375 17.5626 25.0262 17.5057 24.4575Z",
    fill: "url(#paint2_linear_1076_5884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64969 15.1567H5.6875C5.6875 10.7751 9.18706 7.19591 13.5376 7.06641C13.6185 7.06423 13.4811 7.50041 13.5625 7.50041L13.7812 9.0251C10.4002 9.0251 7.64969 11.7757 7.64969 15.1567Z",
    fill: "url(#paint3_linear_1076_5884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4439 14.6386C13.4439 14.6386 13.629 14.9597 13.9996 14.9356C14.3701 14.9116 14.4782 14.6027 14.5088 14.4837C14.5394 14.3647 14.8794 10.2154 14.8794 10.0133C14.8794 9.8112 14.7096 9.39514 14.6322 9.13351C14.5547 8.87189 14.1177 7.5047 14.0455 7.33801C13.9064 7.01689 13.181 6.89789 13.0729 7.48064C12.9828 7.97064 12.6875 11.9873 12.6875 11.9873C12.6875 11.9873 12.6875 12.3321 12.8266 12.784C12.9653 13.2355 13.4439 14.6386 13.4439 14.6386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 23.2513C10.9567 23.2513 8.38247 21.8159 6.89453 19.4118L8.56272 18.3789C9.69103 20.2015 11.6414 21.2892 13.7812 21.2892C14.5626 21.2892 15.3234 21.1443 16.0418 20.8591L16.7663 22.6826C15.8156 23.0602 14.8115 23.2513 13.7812 23.2513Z",
    fill: "url(#paint4_linear_1076_5884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9055 19.5422L19.1993 18.5735C19.7199 17.6565 19.9951 16.6113 19.9951 15.55C19.9951 13.2995 18.7648 11.2332 16.7852 10.1578L17.7223 8.43359C20.3346 9.85284 21.9573 12.5793 21.9573 15.55C21.9568 16.95 21.5933 18.3303 20.9055 19.5422Z",
    fill: "url(#paint5_linear_1076_5884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.496 15.7962C13.496 15.7962 13.6714 15.4699 13.4566 15.1671C13.2418 14.8644 12.922 14.9352 12.8043 14.9716C12.6871 15.0079 8.97924 16.9014 8.8073 17.0077C8.63537 17.114 8.37068 17.4771 8.18912 17.6806C8.00755 17.884 7.07437 18.9747 6.97068 19.1239C6.77074 19.4109 7.05118 20.0903 7.60374 19.8759C8.06793 19.6957 11.6392 17.8341 11.6392 17.8341C11.6392 17.8341 11.9324 17.6526 12.2439 17.2969C12.5545 16.9412 13.496 15.7962 13.496 15.7962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.505 15.7962C14.505 15.7962 14.3296 15.4699 14.5444 15.1671C14.7592 14.8644 15.079 14.9352 15.1967 14.9716C15.3139 15.0079 19.0217 16.9014 19.1937 17.0077C19.3656 17.114 19.6303 17.4771 19.8119 17.6806C19.9934 17.884 20.9266 18.9747 21.0303 19.1239C21.2302 19.4109 20.9498 20.0903 20.3972 19.8759C19.9331 19.6957 16.3617 17.8341 16.3617 17.8341C16.3617 17.8341 16.0686 17.6526 15.7571 17.2969C15.4456 16.9412 14.505 15.7962 14.505 15.7962Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1076_5884",
    x1: 24,
    y1: 50.373,
    x2: 24,
    y2: -23.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#0080E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#009CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1076_5884",
    x1: 7.21941,
    y1: 28.2633,
    x2: 7.21941,
    y2: 4.15794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#0080E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#009CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1076_5884",
    x1: 21.0006,
    y1: 27.2649,
    x2: 21.0006,
    y2: 1.9105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#0080E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#009CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1076_5884",
    x1: 12.0351,
    y1: 7.80933,
    x2: 6.57479,
    y2: 14.5912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1076_5884",
    x1: 7.79101,
    y1: 20.2679,
    x2: 15.0417,
    y2: 21.5866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0280E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1076_5884",
    x1: 20.4397,
    y1: 18.5154,
    x2: 18.9373,
    y2: 10.0532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A7EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1076_5884"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 28,
    height: 28,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestflight);
export default __webpack_public_path__ + "static/media/testflight.82320caab4c46530f8cb778f7439c462.svg";
export { ForwardRef as ReactComponent };